module.exports = __webpack_public_path__ + "img/lo-studio-image-1.dbc75e01.png";